<template>
  <vz-dialog
    big
    public
    title="Выберите город"
    name="terminals-location"
    class="vz-region-modal"
    full-screen
    hide-footer
  >
    <region-cities
      :change-city-on-select="false"
      @change="onChange"
    />
  </vz-dialog>
</template>

<script setup lang="ts">
import { Location } from '~/types/types'
import RegionCities from '~/components/public/region-cities/region-cities.vue'

const emit = defineEmits(['change'])
const { $hideDialog } = useNuxtApp()

function onChange(location: Location) {
  emit('change', location)
  $hideDialog({ name: 'terminals-location' })
}
</script>
